// npm install axios

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { BackendURL } from '../utils/BackendURL';

function Signup() {

    // NAVIGATE INITIALIZATION AND LOGIN BUTTON LOGIC:
    const navigate = useNavigate();
    function handleLogin() {
        navigate('/login');
        window.scrollTo(0, 0);
    }

    // FETCH DATA FROM MONGODB FOR CHECKING OF ACCOUNT EXISTENCE:
    const [data, setData] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${BackendURL}/login`);
                setData(response.data);
            } catch (error) {
                console.error('Error fetching data from MongoDB:', error);
            }
        };

        fetchData();
    }, []);



    // CHECK THE ACCOUNT EXISTENCE:
    function checkAccExistence() {
        const userEmail = document.getElementById('email').value;
        const userEmailError = document.getElementById("userEmailError");
        const signupButton = document.getElementById('Signup-button');

        let accountExists = false;

        for (let i = 0; i < data.length; i++) {
            if (data[i].userEmail === userEmail) {
                accountExists = true;
                break;  // Exit the loop once a match is found
            }
        }

        if (accountExists) {
            userEmailError.style.display = 'flex';
            signupButton.disabled = true;  // Disable signup if account exists
        } else {
            userEmailError.style.display = 'none';
            signupButton.disabled = false;  // Enable signup if account doesn't exist
        }
    }



    // ERROR HANDLING OF FORM:
    function errorshandling() {
        const phoneElement = document.getElementById('phone');
        const passwordElement = document.getElementById('password');
        const cpasswordElement = document.getElementById('cpassword');
        const phoneError = document.getElementById('phone-error');
        const passwordError = document.getElementById('password-error');
        const cpasswordError = document.getElementById('cpassword-error');
        const signupButton = document.getElementById('Signup-button');


        if (phoneElement && passwordElement && cpasswordElement) {
            const phone = phoneElement.value;
            const password = passwordElement.value;
            const cpassword = cpasswordElement.value;

            if (phone.length === 11) {
                phoneError.style.display = 'none';
            } else {
                phoneError.style.display = 'flex';
            }

            if (password.length >= 8) {
                passwordError.style.display = 'none';
            } else {
                passwordError.style.display = 'flex';
            }

            if (password === cpassword) {
                cpasswordError.style.display = 'none';
            } else {
                cpasswordError.style.display = 'flex';
            }

            if (phone.length === 11 && password.length >= 8 && password === cpassword) {
                checkAccExistence();
            } else {
                signupButton.disabled = true;
            }
        }
    }



    //SAVE DATA TO MONGO DB:
    const [user, setUser] = useState({
        userName: "", userEmail: "", userAddress: "", userPhone: "", userPassword: "", userConfirmPassword: ""
    });

    const handleInputs = (e) => {
        const { name, value } = e.target;
        setUser((prevUser) => ({ ...prevUser, [name]: value }));
        setTimeout(errorshandling, 1000);  // Call errorshandling after a delay
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const { userName, userEmail, userAddress , userPhone, userPassword } = user;
        const formatDate = (date) => {
            const options = { month: 'long', day: 'numeric', year: 'numeric' };
            return new Date(date).toLocaleDateString('en-US', options);
        };
        
        const memberSince = formatDate(new Date());
        try {
            const res = await axios.post(`${BackendURL}/accounts`, {
                userName,
                userEmail,
                userAddress,
                userPhone,
                userPassword,
                memberSince
            });

            console.log(res.data); // Log the response

            if (res.data.success) {
                navigate('/');
                localStorage.setItem('UserName', JSON.stringify(user.userName))
                localStorage.setItem('UserEmail', JSON.stringify(user.userEmail))
                // window.scrollTo(0, 0); // Scroll to the top when the component mounts
                window.location.reload()
            }


        } catch (error) {
            console.error("Error:", error.message);
        }
    };



    return (
        <main className='signup-main'>
            <div className="login_formdiv">
                <h1 className="signup_h1">SIGN UP</h1>
                <form>
                    <div className="login_formdesign">
                        Name: <input type="text" name="userName" required={true} onChange={handleInputs} id="name" />

                    </div>

                    <div className="login_formdesign">
                        Email: <input type="text" name="userEmail" required={true} onChange={handleInputs} id="email" />
                        <div id="userEmailError" className='errors'>
                            Email is already in use
                        </div>
                    </div>

                    <div className="login_formdesign">
                        Address: <input type="text" placeholder='(OPTIONAL)' name="userAddress" required={true} onChange={handleInputs} id="address" />
                    </div>

                    <div className="login_formdesign">
                        Phone: <input type="text" name="userPhone" required={true} onChange={handleInputs} id="phone" />
                        <div id='phone-error' className='errors'>
                            *Phone Number is Incorrect
                        </div>
                    </div>

                    <div className="login_formdesign">
                        Password: <input type="password" name="userPassword" required={true} onChange={handleInputs} id="password" />
                        <div id='password-error' className='errors'>
                            *Password must be atleast 8 digits
                        </div>
                    </div>

                    <div className="login_formdesign">
                        Confirm Password: <input type="password" name="userConfirmPassword" required={true} onChange={handleInputs} id="cpassword" />
                        <div id='cpassword-error' className='errors'>
                            *Password should be same
                        </div>
                    </div>
                    <input className="login_but" type="submit" value="Sign Up" onClick={handleSubmit} id='Signup-button' />

                </form>
                <p className="text-center">
                    Already have an account?{' '}
                    <button className="login_but" id='loginbutton' onClick={handleLogin}>
                        Login
                    </button>
                </p>
            </div>
        </main>
    )
}

export default Signup;